(function () {
  function bubble(field) {
    if (!field) return;
    field.dispatchEvent(new Event('input',  { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initRangeSliders(root = document) {
    if (!window.noUiSlider) return;

    root.querySelectorAll('.js-range-slider:not([data-initialized="true"])').forEach(sliderEl => {
      const facet = sliderEl.closest('.facets__item');
      if (!facet) return;

      const form       = sliderEl.closest('form');
      const hiddenMin  = facet.querySelector('.facet__hidden-min');
      const hiddenMax  = facet.querySelector('.facet__hidden-max');
      const displayMin = facet.querySelector('.range-display-min');
      const displayMax = facet.querySelector('.range-display-max');

      // All values are already MAJOR units from Liquid
      const rangeMaxRaw = parseFloat(sliderEl.dataset.rangeMax);
      const curMinRaw   = parseFloat(sliderEl.dataset.currentMin);
      const curMaxRaw   = parseFloat(sliderEl.dataset.currentMax);
      const stepRaw     = parseFloat(sliderEl.dataset.step || '1');

      const isFinitePos = n => Number.isFinite(n) && n >= 0;
      const safeRangeMax = isFinitePos(rangeMaxRaw) && rangeMaxRaw > 0 ? rangeMaxRaw
                           : (isFinitePos(curMaxRaw) ? curMaxRaw : 100);
      const startMin     = isFinitePos(curMinRaw) ? curMinRaw : 0;
      const startMax     = isFinitePos(curMaxRaw) && curMaxRaw > 0 ? curMaxRaw : safeRangeMax;
      const stepVal      = Number.isFinite(stepRaw) && stepRaw > 0 ? stepRaw : 1;

      // Build slider
      window.noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: { min: 0, max: safeRangeMax },
        step: stepVal,
        behaviour: 'tap-drag'
      });

      // Initialize visible/hidden (MAJOR units) + bubble so Horizon picks them up
      if (displayMin) displayMin.value = Math.round(startMin);
      if (displayMax) displayMax.value = Math.round(startMax);
      if (hiddenMin)  hiddenMin.value  = Math.round(startMin);
      if (hiddenMax)  hiddenMax.value  = Math.round(startMax);
      bubble(hiddenMin); bubble(hiddenMax);

      // Slider → inputs
      sliderEl.noUiSlider.on('update', (values) => {
        const minD = Math.round(values[0]);
        const maxD = Math.round(values[1]);
        if (displayMin) displayMin.value = minD;
        if (displayMax) displayMax.value = maxD;
        if (hiddenMin)  hiddenMin.value  = minD;
        if (hiddenMax)  hiddenMax.value  = maxD;
        bubble(hiddenMin); bubble(hiddenMax);
      });

      // Inputs → slider
      const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
      displayMin && displayMin.addEventListener('change', () => {
        const minVal = parseFloat(displayMin.value || '0');
        const maxVal = parseFloat(displayMax.value || String(safeRangeMax));
        sliderEl.noUiSlider.set([clamp(minVal, 0, maxVal), null]);
      });
      displayMax && displayMax.addEventListener('change', () => {
        const minVal = parseFloat(displayMin.value || '0');
        const maxVal = parseFloat(displayMax.value || String(safeRangeMax));
        sliderEl.noUiSlider.set([null, clamp(maxVal, minVal, safeRangeMax)]);
      });

      // Optional: auto-submit on release (matches Horizon UX)
      let t;
      sliderEl.noUiSlider.on('end', () => {
        if (!form) return;
        clearTimeout(t);
        t = setTimeout(() => {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        }, 200);
      });

      sliderEl.setAttribute('data-initialized', 'true');
    });
  }

  // Keep your previous hooks if they were working:
  document.addEventListener('DOMContentLoaded', () => initRangeSliders());
  document.addEventListener('shopify:section:load', (e) => initRangeSliders(e.target));
})();
